import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBranch'
})
export class FilterBranchPipe implements PipeTransform {


  transform(value: any[], branchContactId: number, dispatch: any, selectedBranchId: string): any[] {
    if(dispatch?.branch){
      const selected = Number(selectedBranchId) || branchContactId;
      const filteredCartByBranch = value.map(cart => {
        cart.isInBranch = cart.branchContactId !== selected ? false : true;
        return cart;
      });
      const filteredCart = filteredCartByBranch.filter(x => x.branchContactId === selected);
      return filteredCart;
    }else{
      value.forEach(x => x.isInBranch = true);
      return value;
    }
  }

}
